// Encodes special characters. Specifically parentheses that we can have in insurance values.
// router.navigate fails to encode certain characters.
// This functions helps us handle cases like:  Optum/United-EAP (CO).

export const encodeSpecialCharacters = (str: string): string => str.replace(/[!'(),*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);

export const fixBadDoubleEncoding = (url: string): string => {
  // Allowed special characters that can remain double encoded.
  const allowedSpecialChars = new Set(['!', "'", '(', ')', '*']);

  // Regex to find double-encoded sequences: "%25" followed by two hexadecimal digits.
  return url.replace(/%25([0-9A-Fa-f]{2})/g, (match, hexDigits) => {
    // Convert the hex digits to the corresponding character.
    const decodedChar = String.fromCharCode(parseInt(hexDigits, 16));
    // If the decoded character is allowed, keep the double encoding.
    if (allowedSpecialChars.has(decodedChar)) {
      return match;
    }
    // Otherwise, convert to single encoding by returning "%" followed by the hex digits in uppercase.
    return `%${hexDigits.toUpperCase()}`;
  });
};

export const hasBadDoubleEncoding = (url: string): boolean => {
  // Allowed special characters that may be double encoded.
  const allowedSpecialChars = new Set(['!', "'", '(', ')', ',', '*']);

  // Regex to find any instance of double encoding, i.e., "%25" followed by two hexadecimal digits.
  const regex = /%25([0-9A-Fa-f]{2})/g;
  let match: RegExpExecArray | null;

  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(url)) !== null) {
    // match[1] contains the two hex digits that follow %25.
    const hexDigits = match[1];
    // Convert the hex value to the actual character.
    const decodedChar = String.fromCharCode(parseInt(hexDigits, 16));

    // If the decoded character is not one of the allowed special characters,
    // then this double encoding is not permitted.
    if (!allowedSpecialChars.has(decodedChar)) {
      return true;
    }
  }
  return false;
};
